import { render, staticRenderFns } from "./SKBooking.vue?vue&type=template&id=62b7d97e&scoped=true&"
import script from "./SKBooking.vue?vue&type=script&lang=js&"
export * from "./SKBooking.vue?vue&type=script&lang=js&"
import style0 from "./SKBooking.vue?vue&type=style&index=0&id=62b7d97e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b7d97e",
  null
  
)

export default component.exports